<section class="blog blog-grid pt-70 pb-90">
    <div class="container pairblank">
        <div class="page__section">
            <nav class="breadcrumb breadcrumb_type5" aria-label="Breadcrumb">
                <ol class="breadcrumb__list r-list">
                    <li class="breadcrumb__group">
                        <a [routerLink]="['/crypto']" class="breadcrumb__point r-link" title="Kriptolar">Kriptolar</a>
                        <span class="breadcrumb__divider" aria-hidden="true">›</span>
                    </li>
                    <li class="breadcrumb__group">
                        <span class="breadcrumb__point" aria-current="page">{{detail?.code}}</span>
                    </li>
                </ol>
            </nav>
        </div><div class="row">
            <div class="col-sm-12 col-md-12 col-lg-8 mb-30-xs mb-30-sm">
                <div class="row ">
                   <div class="row row-2">
                    <div class="col-md-12"> <h1  class="info-detail-title">{{detail?.name}}</h1></div>
                    <div class="mb-3 mt-3" *ngIf="isBrowser">
                        <share-buttons [theme]="'circles-light'"
                            [include]="['facebook','twitter','linkedin','pinterest','reddit','tumblr','mix','viber','vk','telegram','messenger','whatsapp','xing','line','sms','email','print','copy']"
                            [exclude]="['mix','viber','xing','sms','email','print']" [show]="3" [autoSetMeta]="false">
                        </share-buttons>
                    </div>
                   </div>

                    <div class="row">
                        <div class="col" style="font-weight:bold;">Adı-Kodu</div>
                        <div class="col">{{detail?.name}}~{{detail?.code}} </div>
                        <div class="w-100"></div>
                        <div class="col" style="font-weight:bold;">Tarih</div>
                        <div class="col">{{detail?.date | date:'d MMMM y'}}</div>
                        <div class="w-100"></div>
                        <div class="col" style="font-weight:bold;">Fiyatı</div>
                        <div class="col">{{detail?.price | number}}</div>
                        <div class="w-100"></div>
                        <div class="col" style="font-weight:bold;">Değişim</div>
                        <div class="col">{{detail?.change }}</div>
                        <div class="w-100"></div>                
                        <div class="col" style="font-weight:bold;" i18n="@@distributionMethod">Değeri</div>
                        <div class="col">{{detail?.volume | number }}</div>
                    </div>
                    <app-coin-chart [code]="detail?.code"></app-coin-chart>
                </div>
                <br><br>
                <div class="widget market-pricing market-list card mb-3" style="position: relative; padding:10px;">
                    <div class="row">
                        <div class="col-4" style="width:auto;height:auto;">
                            <picture>
                                <source media="(max-width: 90px)" srcset="{{domainURL}}halka-arz.webp" />
                                <source media="(min-width: 90px)" srcset="{{domainURL}}halka-arz.webp" />
                                <img loading="lazy" width="90px" height="60px" src="{{domainURL}}halka-arz.webp"
                                    alt="Halka Arz Haberler" title="Halka Arz Haberler">
                            </picture>

                        </div>
                        <div class="col-8"><h3 class="h5"><strong>Kripto Para Nedir?</strong></h3> Bir kripto para birimi, kriptografi ile güvence altına alınan, sahteciliği veya çifte harcamayı neredeyse imkansız hale getiren dijital veya sanal bir para birimidir. </div>
                    <div class="w-100"></div>
                    <br>
                    <p>Kripto para birimlerinin tanımlayıcı bir özelliği, genellikle herhangi bir merkezi otorite tarafından verilmemeleri ve teorik olarak hükümet müdahalesine veya manipülasyonuna karşı bağışıklık kazanmalarıdır.</p>
                    <h4 class="h6">Kripto Para Birimi Türleri</h4>
                    <p>Bitcoin en popüler ve değerli kripto para birimidir. Satoshi Nakamoto adlı anonim bir kişi onu 2008 yılında icat etti ve bir beyaz kağıt aracılığıyla dünyaya tanıttı. Bugün piyasada binlerce kripto para birimi var.</p>
                    <p>Her kripto para birimi farklı bir işleve ve spesifikasyona sahip olduğunu iddia ediyor. Örneğin, Ethereum'un etheri , kendisini temel akıllı sözleşme platformu için gaz olarak pazarlar. Ripple'ın XRP'si, bankalar tarafından farklı coğrafyalar arasındaki transferleri kolaylaştırmak için kullanılır.</p>
                    <p>2009 yılında halka sunulan Bitcoin, en çok işlem gören ve kapsanan kripto para birimi olmaya devam ediyor. Mayıs 2022 itibariyle, toplam piyasa değeri yaklaşık 576 milyar dolar olan 19 milyonun üzerinde bitcoin dolaşımdaydı. Sadece 21 milyon bitcoin var olacak. </p>
                    <p>Bitcoin'in başarısının ardından, "altcoins" olarak bilinen diğer birçok kripto para birimi piyasaya sürüldü. Bunlardan bazıları Bitcoin'in klonları veya çatalları iken diğerleri sıfırdan oluşturulmuş yeni para birimleridir. Bunlar Solana, Litecoin , Ethereum, Cardano ve EOS'u içerir . Kasım 2021'e kadar, mevcut tüm kripto 
                        para birimlerinin toplam değeri 2,1 trilyon doları aşmıştı - Bitcoin bu toplam değerin yaklaşık %41'ini temsil ediyordu.</p>
                    <h4 class="h6">En Popüler Kripto Para Birimleri Nelerdir?</h4>
                    <p>Bitcoin, açık ara en popüler kripto para birimidir ve bunu Ethereum, Binance Coin, Solana ve Cardano gibi diğer kripto para birimleri takip eder</p>
                        <p>Kripto haber, kripto para yorumları ve kripto para fiyatlarına <strong><a [routerLink]="'/crypto'" title="Kripto Para" >Kripto Para </a></strong>sayfamızdan ulaşabilirsiniz!</p>
                    
                        <div class="col-8"><strong>Kripto Paralar</strong> hakkında daha fazlasını öğrenmek için <a
                                [routerLink]="'/info/crypto-nedir'"> Kripto Para Nedir?</a> yazımızı okuyabilirsiniz.</div>
                        <div class="w-100"></div>
                        <br>
                        <p>Şirketlerin haberlerine <strong><a [routerLink]="'/company-news'">Şirket Haberleri
                                </a></strong>sayfamızdan ulaşabilirsiniz.</p>
                    </div>
                    
                </div>
                <br>
            <div class="m-2" style="text-align:center;" *ngIf="isBrowser">
                <share-buttons [theme]="'circles-light'"
                    [include]="['facebook','twitter','linkedin','pinterest','reddit','tumblr','mix','viber','vk','telegram','messenger','whatsapp','xing','line','sms','email','print','copy']"
                    [exclude]="['mix','viber','xing','sms','email','print']" [show]="3" [autoSetMeta]="false">
                </share-buttons>
            </div>
            <div style="text-align: center;">
                <app-comment [commentCount]="commentCount"  [title]="title" [rootId]="rootId"></app-comment>
            </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-4">
                <app-draft-month [toYear]="toYear"></app-draft-month>
                <app-draft-dividend [toYear]="toYear"></app-draft-dividend>
                <app-summary-info></app-summary-info>
                <app-summary-analysis [imageStatus]="true" [count]="5"></app-summary-analysis>  
            </div>
        </div>
        
    </div>
</section>